/* Azends x Heriots: behaviour for the az- sections. Safe to run more than once (theme editor reloads). */
(function(){
  'use strict';
  var D=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var DF=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  function tmrw(){var d=new Date();d.setDate(d.getDate()+1);return D[d.getDay()]+' '+d.getDate()+' '+M[d.getMonth()]}
  function tmrwDay(){var d=new Date();d.setDate(d.getDate()+1);return DF[d.getDay()]}
  function pad(n){return String(n).padStart(2,'0')}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  var KEY='az_pc',state=null;
  try{state=JSON.parse(localStorage.getItem(KEY)||'null')}catch(e){}

  /* countdown to midnight */
  function tick(){
    var n=new Date(),m=new Date(n);m.setHours(24,0,0,0);var s=Math.max(0,Math.floor((m-n)/1000));
    $$('[data-az-cd]').forEach(function(e){e.textContent=Math.floor(s/3600)+'h '+pad(Math.floor(s%3600/60))+'m'});
    $$('[data-az-tm]').forEach(function(e){e.textContent=tmrw()});
    paintDel();
  }

  /* postcode */
  function parse(v,zones){
    var raw=String(v||'').toUpperCase().replace(/[^A-Z0-9 ]/g,' ').trim(),parts=raw.split(/\s+/).filter(Boolean),m=null;
    if(parts.length>1&&/^[A-Z]{1,2}\d[A-Z\d]?$/.test(parts[0])){
      var a=parts[0].match(/^([A-Z]{1,2})(\d[A-Z\d]?)$/);
      m=[null,a[1],a[2],/^\d[A-Z]{2}$/.test(parts[1])?parts[1]:undefined];
    }else{m=raw.replace(/\s+/g,'').match(/^([A-Z]{1,2})(\d[A-Z\d]?)(\d[A-Z]{2})?$/)}
    if(!m)return{valid:false};
    return{valid:true,area:m[1],out:m[1]+m[2],full:m[3]?m[1]+m[2]+' '+m[3]:m[1]+m[2],ok:zones.indexOf(m[1])>-1};
  }
  function zonesOf(el){return String(el.getAttribute('data-zones')||'').toUpperCase().split(/[\s,]+/).filter(Boolean)}
  function msg(r){
    if(!r.valid)return '<b>Check that postcode.</b> Try something like HA4 7BD.';
    if(r.ok)return '<b>Yes, we deliver to '+r.out+'.</b> Order by midnight and it arrives <b>'+tmrw()+'</b>, 8am to 2pm.';
    return '<b>Not to '+r.out+' yet.</b> Collect free from our Slough shop instead.';
  }
  function paintDel(){
    $$('[data-az-del]').forEach(function(e){
      e.classList.remove('is-ok','is-no');
      if(state&&!state.ok){e.classList.add('is-no');e.innerHTML='<i></i>Collect '+tmrwDay();return}
      e.classList.add('is-ok');e.innerHTML='<i></i>Arrives '+tmrwDay();
    });
    $$('[data-az-area]').forEach(function(e){e.classList.toggle('is-hit',!!state&&e.getAttribute('data-az-area')===state.area)});
    $$('[data-az-pc] input').forEach(function(i){if(state&&document.activeElement!==i&&!i.value)i.value=state.full});
  }
  function bindPc(form){
    if(form.__az)return;form.__az=1;
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var r=parse(form.querySelector('input').value,zonesOf(form));
      var box=form.querySelector('.az-res');
      box.className='az-res is-open '+(r.valid?(r.ok?'is-yes':'is-no'):'');
      box.firstElementChild.innerHTML='<div class="az-r">'+msg(r)+'</div>';
      if(r.valid){state={full:r.full,area:r.area,ok:r.ok};try{localStorage.setItem(KEY,JSON.stringify(state))}catch(err){}paintDel()}
    });
  }

  /* hero slideshow */
  function bindHero(h){
    if(h.__az)return;h.__az=1;
    var slides=$$('.az-hs',h),dots=$$('.az-dots button',h),i=0,t,sp=(parseInt(h.getAttribute('data-speed'),10)||5)*1000;
    function go(n){i=n;slides.forEach(function(s,k){s.classList.toggle('is-on',k===n)});dots.forEach(function(d,k){d.classList.toggle('is-on',k===n)});next()}
    function next(){clearTimeout(t);if(slides.length>1)t=setTimeout(function(){go((i+1)%slides.length)},sp)}
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k)})});
    requestAnimationFrame(function(){h.classList.add('is-go')});next();
  }

  /* tabs */
  function bindTabs(w){
    if(w.__az)return;w.__az=1;
    var btns=$$('[data-az-tab]',w),panels=$$('[data-az-panel]',w);
    btns.forEach(function(b){b.addEventListener('click',function(){
      var id=b.getAttribute('data-az-tab');
      btns.forEach(function(x){x.classList.toggle('is-on',x===b)});
      panels.forEach(function(p){p.hidden=p.getAttribute('data-az-panel')!==id});
    })});
  }

  /* carousel arrows */
  function bindCar(w){
    if(w.__az)return;w.__az=1;
    var track=w.querySelector('.az-car');if(!track)return;
    $$('[data-az-prev]',w).forEach(function(b){b.addEventListener('click',function(){track.scrollBy({left:-320,behavior:'smooth'})})});
    $$('[data-az-next]',w).forEach(function(b){b.addEventListener('click',function(){track.scrollBy({left:320,behavior:'smooth'})})});
  }

  /* reveal */
  var io='IntersectionObserver' in window?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.08}):null;
  function bindRv(el){if(el.__az)return;el.__az=1;if(io)io.observe(el);else el.classList.add('is-in')}

  function init(root){
    root=root||document;
    $$('[data-az-hero]',root).forEach(bindHero);
    $$('[data-az-pc]',root).forEach(bindPc);
    $$('[data-az-tabs]',root).forEach(bindTabs);
    $$('[data-az-carousel]',root).forEach(bindCar);
    $$('.az-rv',root).forEach(bindRv);
    paintDel();tick();
  }
  function boot(){
    init(document);setInterval(tick,30000);
    setTimeout(function(){$$('.az-rv').forEach(function(el){var r=el.getBoundingClientRect();if(r.top<innerHeight)el.classList.add('is-in')})},1500);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(e){init(e.target);$$('.az-rv',e.target).forEach(function(el){el.classList.add('is-in')})});
})();

/* Azends: sticky add to cart on product pages. It only ever clicks the theme's own button, so the plaque and delivery apps keep working. */
(function(){
  function init(){
    if(!document.body.classList.contains('template-product')||document.querySelector('.az-sticky'))return;
    var real=document.querySelector('form[data-product-form] [data-add-to-cart]')||document.querySelector('.btn--add-to-cart');
    if(!real)return;
    var titleEl=document.querySelector('.product__title__wrapper')||document.querySelector('h1');
    var priceEl=document.querySelector('.product__price__wrap');
    var opts=document.querySelector('.product__block__variants .radio__fieldset, .product__block__variants .select__fieldset')||document.querySelector('[class*=spb-io-field]')||real;
    var hasSizes=document.querySelectorAll('.product__block__variants .radio__button').length>1||!!document.querySelector('.product__block__variants .select__fieldset');
    var bar=document.createElement('div');
    bar.className='az-sticky';
    bar.innerHTML='<div class="az-sticky-t"><b></b><span></span></div><button type="button"></button>';
    document.body.appendChild(bar);
    var t=bar.querySelector('b'),s=bar.querySelector('span'),go=bar.querySelector('button');
    var where='below';
    function chosen(){
      var v=[];
      document.querySelectorAll('.product__block__variants input[type=radio]:checked, .product__block__variants [data-popout-input]').forEach(function(i){v.push(i.value)});
      return v.join(' / ');
    }
    function paint(){
      t.textContent=(titleEl?titleEl.textContent:'').replace(/\s+/g,' ').trim();
      var m=priceEl?(priceEl.textContent.match(/£\s?[\d,]+(\.\d+)?/)||[''])[0]:'';
      s.textContent=[m,chosen()].filter(Boolean).join(' · ');
      var sold=real.disabled;
      go.disabled=sold;
      go.textContent=sold?'Sold out':(where==='below'&&hasSizes?'Choose size':'Add to cart');
    }
    function show(on){bar.classList.toggle('is-on',on);document.body.classList.toggle('az-sticky-on',on)}
    go.addEventListener('click',function(){
      if(where==='below'&&hasSizes){
        var y=opts.getBoundingClientRect().top+scrollY-110;
        window.scrollTo({top:y,behavior:'smooth'});
        return;
      }
      real.scrollIntoView({block:'center',behavior:'smooth'});
      /* click the plaque app's overlay when it exists, exactly like a real tap, so the cake is only added once */
      setTimeout(function(){(real.querySelector('.sp-validate-overlay')||real).click()},350);
    });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          where=e.boundingClientRect.top<0?'above':'below';
          show(!e.isIntersecting);paint();
        });
      },{threshold:0}).observe(real);
    }
    document.addEventListener('change',function(){setTimeout(paint,60)});
    if(priceEl&&'MutationObserver' in window)new MutationObserver(paint).observe(priceEl,{childList:true,subtree:true,characterData:true});
    new MutationObserver(paint).observe(real,{attributes:true,attributeFilter:['disabled']});
    paint();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* Azends: after the main Add to cart succeeds, always land on the basket (that is where the delivery date is picked).
   The plaque app adds items itself and used to leave shoppers on the product page with no feedback. */
(function(){
  if(!document.body.classList.contains('template-product'))return;
  var armed=0,sent=false;
  document.addEventListener('click',function(e){
    var t=e.target;
    if(t&&t.closest&&t.closest('form[data-product-form] [data-add-to-cart]'))armed=Date.now();
  },true);
  function go(){
    if(sent||!armed||Date.now()-armed>10000)return;
    sent=true;
    setTimeout(function(){if(location.pathname.indexOf('/cart')!==0)location.href=(window.theme&&theme.routes&&theme.routes.cart)||'/cart'},700);
  }
  function isAdd(u){return /\/cart\/add/.test(String(u||''))}
  var of=window.fetch;
  if(of)window.fetch=function(input){
    var u=typeof input==='string'?input:(input&&input.url);
    var p=of.apply(this,arguments);
    if(isAdd(u))p.then(function(r){if(r&&r.ok)go()},function(){});
    return p;
  };
  var oo=XMLHttpRequest.prototype.open,os=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(m,u){this.__azAdd=isAdd(u);return oo.apply(this,arguments)};
  XMLHttpRequest.prototype.send=function(){var x=this;if(x.__azAdd)x.addEventListener('load',function(){if(x.status>=200&&x.status<300)go()});return os.apply(this,arguments)};
})();

/* Azends: if "Yes please" is picked for a plaque, the message is required before it can go in the basket. */
(function(){
  if(!document.body.classList.contains('template-product'))return;
  function missing(){
    var yes=[].slice.call(document.querySelectorAll('.spb-option-values input[type=radio]')).filter(function(i){return i.checked&&/yes/i.test(i.value)})[0];
    if(!yes)return null;
    var f=[].slice.call(document.querySelectorAll('[class*=spb-io-field] input[type=text], [class*=spb-io-field] textarea')).filter(function(e){return e.offsetParent!==null})[0];
    return f&&!f.value.trim()?f:null;
  }
  window.addEventListener('click',function(e){
    var t=e.target;
    if(!(t&&t.closest&&t.closest('form[data-product-form] [data-add-to-cart]')))return;
    var f=missing();if(!f)return;
    e.preventDefault();e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();
    var box=f.parentNode.querySelector('.az-need');
    if(!box){box=document.createElement('p');box.className='az-need';box.textContent='Add the message for your plaque, or choose No thanks.';f.insertAdjacentElement('afterend',box)}
    f.classList.add('az-need-f');
    f.scrollIntoView({block:'center',behavior:'smooth'});
    setTimeout(function(){try{f.focus({preventScroll:true})}catch(err){f.focus()}},300);
    f.addEventListener('input',function h(){if(f.value.trim()){box.remove();f.classList.remove('az-need-f');f.removeEventListener('input',h)}});
  },true);
})();

/* Azends: on phones, keep the chat bubble off the hero so it never covers the postcode box. */
(function(){
  function init(){
    var h=document.querySelector('.az-hero');
    if(!h)return;
    function upd(){var r=h.getBoundingClientRect();var seen=Math.max(0,Math.min(r.bottom,innerHeight)-Math.max(r.top,0));document.body.classList.toggle('az-hero-on',r.height>0&&seen/r.height>0.35)}
    upd();addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* Azends: product page delivery card. Reads the delivery app's own dates, so it always matches what the basket offers. */
(function(){
  if(!document.body.classList.contains('template-product'))return;
  var D=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],DF=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var VAN='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>';
  var SHOP='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 9l1.5-5h13L20 9M4 9v11h16V9M4 9h16M9 20v-6h6v6"/></svg>';
  function fmt(d){return D[d.getDay()]+' '+d.getDate()+' '+M[d.getMonth()]}
  function pd(s){var m=/(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(s||'');return m?new Date(+m[3],+m[2]-1,+m[1]):null}
  function same(a,b){return !!a&&!!b&&a.toDateString()===b.toDateString()}
  var card=null,tries=0;
  function paint(){
    if(!card)return;
    var txt=(document.getElementById('cc-shortest-date')||{}).textContent||'';
    var lm=/Delivery:\s*([\d\/]+)/i.exec(txt),pm=/(?:Pick\s*up|Collection)[^:]*:\s*([\d\/]+)/i.exec(txt);
    var t=new Date();t.setDate(t.getDate()+1);
    var ld=(lm&&pd(lm[1]))||t,pk=(pm&&pd(pm[1]))||t;
    var n=new Date(),mid=new Date(n);mid.setHours(24,0,0,0);var s=Math.max(0,Math.floor((mid-n)/1000));
    var left=Math.floor(s/3600)+'h '+String(Math.floor(s%3600/60)).padStart(2,'0')+'m';
    var h=card.querySelector('[data-h]'),sm=card.querySelector('[data-s]'),p=card.querySelector('[data-p]');
    if(same(ld,t)){
      h.textContent='Order by midnight for next-day delivery';
      sm.innerHTML='<em>'+left+' left</em>Arrives tomorrow, '+fmt(ld)+', 8am to 2pm';
    }else{
      h.textContent='Delivery from '+DF[ld.getDay()]+' '+ld.getDate()+' '+M[ld.getMonth()];
      sm.textContent='Delivered 8am to 2pm. Pick your date in the basket.';
    }
    p.textContent='271 High Street, SL1 1BN. Ready from '+(same(pk,t)?'tomorrow, ':'')+fmt(pk)+'.';
  }
  function build(){
    var sh=document.getElementById('cc-shortest');
    if(!sh){if(++tries<40)setTimeout(build,250);return}
    card=document.createElement('div');card.className='az-dcard';
    card.innerHTML='<div class="az-dc-row"><span class="az-dc-ic">'+VAN+'</span><div><b data-h></b><small data-s></small></div></div>'+
      '<div class="az-dc-row az-dc-pick"><span class="az-dc-ic az-dc-ic--soft">'+SHOP+'</span><div><b>Or Click &amp; Collect from our Slough shop</b><small data-p></small></div></div>';
    sh.parentNode.insertBefore(card,sh);
    document.body.classList.add('az-dc');
    paint();
    if('MutationObserver' in window)new MutationObserver(paint).observe(sh,{childList:true,subtree:true,characterData:true});
    setInterval(paint,30000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build);else build();
})();

/* Azends: basket. Add-ons row, "Checkout" wording, and the Slough shop shown clearly for Store Pick up. */
(function(){
  if(!document.body.classList.contains('template-cart'))return;
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function place(){
    var a=document.querySelector('[data-az-addons]'),body=document.querySelector('.template__cart__body'),foot=body&&body.querySelector('.template__cart__footer');
    if(a&&body&&foot&&a.parentNode!==body)body.insertBefore(a,foot);
  }
  document.addEventListener('click',function(e){
    var b=e.target&&e.target.closest&&e.target.closest('[data-az-add]');
    if(!b)return;
    e.preventDefault();
    var sel=b.parentNode.querySelector('[data-az-var]');
    var id=b.getAttribute('data-az-add')||(sel&&sel.value);
    if(!id||b.disabled)return;
    b.disabled=true;b.textContent='Adding';
    fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+id,quantity:1}]})})
      .then(function(r){if(!r.ok)throw new Error('add');b.textContent='Added';location.reload()})
      .catch(function(){b.disabled=false;b.textContent='Try again'});
  });
  var STORE='271 High Street, Slough SL1 1BN',HOURS='Mon to Sat 10am to 6:30pm, Sun 11am to 4:30pm';
  function fix(){
    document.querySelectorAll('.checkout__button,button[name=checkout]').forEach(function(btn){
      var w=document.createTreeWalker(btn,NodeFilter.SHOW_TEXT),n;
      while((n=w.nextNode()))if(/check\s+out/i.test(n.nodeValue))n.nodeValue=n.nodeValue.replace(/check\s+out/ig,'Checkout');
    });
    document.querySelectorAll('.cc-slot-item').forEach(function(it){
      if(!/pick\s*up|collect/i.test(it.textContent)||it.querySelector('.az-slot-sub'))return;
      var sp=it.querySelector('span');if(!sp)return;
      var sub=document.createElement('small');sub.className='az-slot-sub';sub.textContent='Slough shop';
      sp.insertAdjacentElement('afterend',sub);
    });
    document.querySelectorAll('.cc-calendar-overall').forEach(function(o){
      var pick=o.querySelector('.cc-slot-item.is-active'),on=!!pick&&/pick\s*up|collect/i.test(pick.textContent);
      var box=o.querySelector('.az-pick-info');
      if(on&&!box){
        box=document.createElement('div');box.className='az-pick-info';
        box.innerHTML='<b>Collect from Heriots Slough</b><span>'+STORE+'</span><span>'+HOURS+'</span>';
        var slot=o.querySelector('#cc-calendar-slot')||o.firstElementChild;
        slot.parentNode.insertBefore(box,slot.nextSibling);
      }else if(!on&&box){box.remove()}
    });
  }
  var busy=false,tmr=0;
  function run(){if(busy)return;busy=true;try{place();fix()}finally{busy=false}}
  function init(){
    run();
    var target=document.querySelector('.cart__template')||document.body;
    if('MutationObserver' in window)new MutationObserver(function(){if(busy)return;clearTimeout(tmr);tmr=setTimeout(run,40)}).observe(target,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(){setTimeout(run,50)});
})();
